import { defineComponent as _defineComponent } from 'vue'
import MyProjectsSection from '@/views/my-projects/components/MyProjectsSection.vue';
import InvoicesTable from '@/views/my-projects/components/invoices/InvoicesTable.vue';
import { computed } from 'vue';
import useInvoice from '@/views/my-projects/composables/useInvoice';
import useUser from '@/mixins/useUser';
import { InvoiceStatus } from '@/models/Invoice';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesOutgoing',
  setup(__props) {

const { componentInvoicesUserAsReceiver } = useInvoice();
const { userId, tUserFallback: t } = useUser('self');

const outgoingInvoices = computed(() => componentInvoicesUserAsReceiver.value.filter((invoice) => invoice.user.userId !== userId.value && invoice.status !== InvoiceStatus.Draft));


return { __sfc: true,componentInvoicesUserAsReceiver, userId, t, outgoingInvoices, MyProjectsSection, InvoicesTable }
}

})